import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import Dashboard from "../screens/Dashboard";
import Register from "../screens/register";
import ScanCard from "../screens/ScanScard";
import MemberList from "../screens/MemberList";
import Calendar from "../screens/Calendar";
import Events from "../screens/Events";
import Branches from "../screens/Branches";
import Scanners from "../screens/Scanners";
import ReportHome from "../screens/ReportHome";
import AttandanceList from "../screens/AttandanceList";
import Chat from "../screens/Chat";
import BulkSms from "../screens/BulkSms";

function DashRoutes() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Dashboard />}>
          {/* Default route to dashboard */}
          <Route index element={<Dashboard />} />
        </Route>
        {/* Other routes */}
        <Route path="/register" element={<Register />} />
        <Route path="/members" element={<MemberList />} />
        <Route path="/calendar" element={<Calendar />} />
        <Route path="/scan/:param" element={<ScanCard />} />
        <Route path="/events" element={<Events />} />
        <Route path="/branches" element={<Branches />} />
        <Route path="/scanners" element={<Scanners />} />
        <Route path="/attandance" element={<ReportHome />} />
        <Route path="/attandance_list/:param" element={<AttandanceList />} />
        <Route path="/chat" element={<Chat />} />
        <Route path="/bulksms" element={<BulkSms />} />
        {/* Catch-all route */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );
}
export default DashRoutes;
